export default __webpack_public_path__ + "static/media/1.40b5eac9.webp";